import { jsx as _jsx } from "preact/jsx-runtime";
import { useEffect } from 'react';
import clsx from 'clsx';
import styles from './styles/Modal.module.scss';
const Modal = ({ id, ref, children, backgroundColor, height, width, backgroundUrl, extraCSS, overrideCSS, modalImpression, }) => {
    useEffect(() => {
        if (modalImpression) {
            modalImpression();
        }
    }, [modalImpression]);
    const defaultStyle = Object.assign(Object.assign({ backgroundColor,
        height,
        width }, (backgroundUrl ? { backgroundImage: `url(${backgroundUrl})` } : {})), extraCSS);
    const modalClass = clsx({
        [styles.modal]: !overrideCSS,
        [styles.backgroundImage]: backgroundUrl,
    });
    return (_jsx("div", Object.assign({ id: id, ref: ref, class: modalClass, style: overrideCSS ? overrideCSS : defaultStyle }, { children: children }), void 0));
};
export default Modal;
